import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../services/app-config.service';
import { HandsetService } from '../../services/handset.service';

@Component({
  standalone: false,
  selector: 'app-maintenance',
  styleUrls: ['./maintenance.component.scss'],
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent implements OnInit {
  public details: string;
  public imageLoaded: boolean;

  constructor(private appConfig: AppConfig, public handsetService: HandsetService) {
  }

  ngOnInit(): void {

    var maintenance = this.appConfig.config.maintenance;

    if (maintenance.planned) {
      if (maintenance.plan.showEndDate) {
        this.details = 'Planujemy zakończyć prace o godzinie: ' + maintenance.plan.to.toString();
      } else if (maintenance.plan.showBreakInMin) {
        this.details = 'Planujemy zakończyć prace w ciągu ' + maintenance.plan.shownBreakInMin + ' minut';
      }
    }

  }

  public openContactInNewTab() {
    window.open('https://payka.pl/kontakt', '_blank', 'noopener,noreferrer');

  }

  onImageLoad() {
      this.imageLoaded = true;
  }
}
